export default "__VITE_ASSET__BDVurTRP__"